import clsx from 'clsx'
import type { ReactNode, ThHTMLAttributes, TdHTMLAttributes } from 'react'

interface TableProps {
  children: ReactNode
  className?: string
}

export default function Table({ children, className }: TableProps) {
  return (
    <div className="overflow-x-auto">
      <table className={clsx('w-full', className)}>
        {children}
      </table>
    </div>
  )
}

function Thead({ children }: { children: ReactNode }) {
  return (
    <thead className="border-b border-gray-200">
      {children}
    </thead>
  )
}

function Th({ children, className, ...props }: ThHTMLAttributes<HTMLTableCellElement> & { children?: ReactNode }) {
  return (
    <th
      className={clsx(
        'px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider',
        className,
      )}
      {...props}
    >
      {children}
    </th>
  )
}

function Tbody({ children }: { children: ReactNode }) {
  return <tbody className="divide-y divide-gray-100">{children}</tbody>
}

function Tr({ children, className, onClick }: { children: ReactNode; className?: string; onClick?: () => void }) {
  return (
    <tr
      className={clsx('hover:bg-gray-50 transition-colors', onClick && 'cursor-pointer', className)}
      onClick={onClick}
    >
      {children}
    </tr>
  )
}

function Td({ children, className, ...props }: TdHTMLAttributes<HTMLTableCellElement> & { children?: ReactNode }) {
  return (
    <td className={clsx('px-4 py-3.5 text-sm text-gray-700', className)} {...props}>
      {children}
    </td>
  )
}

export { Thead, Th, Tbody, Tr, Td }
